import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ApiModule } from './api.module';
import { BaseApiService } from './base-api.service';

@Injectable({
  providedIn: ApiModule,
  deps: [BaseApiService],
})
export class ProductSelectorApiService {
  constructor(private http: BaseApiService) {}

  /**
   * Get list og NBA (IOT/DS) products
   */
  eligibleProducts(args: { customerId: string; delegationCustcode: string; profile: string }, hideError): Observable<any> {
    let params = new HttpParams();

    params = params.set('channel', 'APP');
    params = params.set('type', 'proposition');
    params = params.set('filterType', 'INNOVATIVE');

    if (args) {
      Object.keys(args).forEach((v) => {
        params = params.set(v, args[v]);
      });
    }
    return this.http.get({
      path: '/productselector/v3/eligibleproducts',
      params,
      hideError
    });
  }

  /**
   * Get list og MM (IOT/DS) products
   */
  productCatalog(args: { custCode: string; username?: string }): Observable<any> {
    let params = new HttpParams();

    params = params.set('customerType', 'CORPORATE');
    params = params.set('catalogType', 'MM');
    params = params.set('productType', 'INNOVATIVE');
    params = params.set('channel', 'APP');
    params = params.set('custCode', args.custCode);
    // MVBA-1455
    params = params.set('addEdition', 'N'); // hide from catalog all products already active on User's Consistency
    params = params.set('isSellable', 'true'); // added 20/04/2021 in DXL -> show only configured ProductOfferings
    params = params.set('limit', '1000'); // added 20/04/2021 in DXL
    // limit field is not mandatory but if this is null, only 10 solution will be returned by DXL.

    if (args.username) {
      params = params.set('username', args.username);
    }

    return this.http.get({
      path: '/productselector/v3/productcatalog',
      params,
    });
  }
}
